<template>
    <h1>Hitmaps</h1>
</template>

<script>
  import MainLayout from "../../layouts/MainLayout"
  export default {
    components: {
      MainLayout
    },
    data() {
      return {}
    }
  }
</script>
